<template>
  <table
    v-if="showComponent"
    width="100%">
    <tr>
      <td nowrap>
        <span>{{ itemCountLabel }}</span>
      </td>
      <td
        v-for="(groupName, index) in groups"
        :key="index">
        <v-btn-toggle
          v-model="dataSelection[index]"
          multiple
          @change="onSelection(index)">
          <v-btn
            v-for="(group) in dataConfig.filter(element => element.group === groupName)"
            :key="group.index"
            :value="group.index"
            text
            small
            color="dover-blue">
            {{ group.desc }}
          </v-btn>
        </v-btn-toggle>
      </td>
      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
      <td class="text-xs-right">
        <v-btn
          v-if="showRefreshButton"
          small
          class="mx-0 font-weight-light"
          color="red"
          @click="onRefresh()">
          {{ refreshLabel }}
        </v-btn>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    dataSelection: {
      type: Array,
      required: true
    },
    dataConfig: {
      type: Array,
      required: true
    },
    showComponent: {
      type: Boolean,
      required: true
    },
    showRefreshButton: {
      type: Boolean,
      required: false,
      default: true
    },
    itemCountLabel: {
      type: String,
      required: false,
      default: ''
    },
    refreshLabel: {
      type: String,
      required: true
    }
  },
  data: () => ({
    groups: [],
    dataSelectionIndex: 0
  }),
  mounted () {
    this.groups = [...new Set(this.dataConfig.map(a => a.group))]
  },
  methods: {
    onRefresh () {
      this.$emit('onRefresh', this.dataSelection, this.dataSelectionIndex)
    },
    onSelection (currIndex) {
      this.dataSelectionIndex = currIndex

      // clear other selection
      for (let index = 0; index < this.dataSelection.length; index++) {
        if (index === currIndex) continue
        this.dataSelection[index] = []
      }
    }
  }
}
</script>
